import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  all: revert;\n\n  display: block;\n  grid-row: 1;\n  grid-column: start / end;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding-block-start: ", ";\n  padding-block-end: ", ";\n  padding-inline-end: var(--select-icon-padding);\n\n  color: var(", ");\n  ", "\n  ", "\n\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: ", ";\n\n  transition-timing-function: var(", ");\n  transition-duration: 0.25s;\n  transition-property: opacity;\n\n  appearance: none;\n\n  &:focus {\n    opacity: 1;\n  }\n\n  &:hover {\n    color: var(", ");\n  }\n\n  &:disabled {\n    color: var(\n      ", "\n    );\n\n    cursor: ", ";\n  }\n\n  option {\n    all: revert;\n    color: initial;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: [start] auto [icon] ", " [end];\n  margin-inline-end: calc(-1 * var(--select-icon-padding));\n\n  ", "\n\n  &::after {\n    grid-column: start / end;\n  }\n\n  color: var(\n    ", "\n  );\n\n  &:hover {\n    color: var(\n      ", "\n    );\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  --select-icon-padding: calc(\n    ", " + ", "\n  );\n\n  padding-inline-end: var(--select-icon-padding);\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  grid-row: 1;\n  grid-column: icon;\n\n  width: ", ";\n  height: ", ";\n\n  *:focus-within > & {\n    padding-block-end: ", ";\n\n    transform: rotateZ(180deg);\n  }\n  *:not(:focus-within) > & {\n    padding-block-start: ", ";\n  }\n\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { getEasing } from '../../utils/getEasing';
import { injectTypography } from '../../utils/injectTypography';
import { injectInteractionBar } from '../../utils/injectInteractionBar';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
var ICON_WIDTH = '24px';
export var StyledIcon = styled.svg(_templateObject(), ICON_WIDTH, ICON_WIDTH, function (props) {
  return "var(".concat(props.theme.responsive.spacing.xxs, ")");
}, function (props) {
  return "var(".concat(props.theme.responsive.spacing.xxs, ")");
});
export var StyledContainer = styled.div(_templateObject2(), ICON_WIDTH, function (props) {
  return "var(".concat(props.theme.responsive.spacing.xs, ")");
}, injectSpacing('margin'));
export var StyledSelectContainer = styled.div(_templateObject3(), ICON_WIDTH, function (props) {
  return !props.readOnly && injectInteractionBar(props);
}, function (props) {
  return props.disabled ? props.theme.colors.interaction.secondary.disabled : props.theme.colors.interaction.secondary.default;
}, function (props) {
  return props.disabled ? props.theme.colors.interaction.secondary.disabled : props.theme.colors.interaction.secondary.hover;
});
export var StyledSelect = styled.select(_templateObject4(), function (props) {
  return "var(".concat(props.theme.responsive.spacing.xxs, ")");
}, function (props) {
  return "var(".concat(props.theme.responsive.spacing.xs, ")");
}, function (props) {
  return props.theme.colors.interaction.secondary.filled;
}, function (props) {
  return injectTypography(props, 'copy1');
}, injectOSXFontSmoothing(true), function (props) {
  return props.empty ? 0 : 1;
}, getEasing, function (props) {
  return props.theme.colors.interaction.secondary.hover;
}, function (props) {
  return props.readOnly ? props.theme.colors.interaction.secondary.readonly : props.theme.colors.interaction.secondary.disabled;
}, function (props) {
  return props.readOnly ? 'default' : 'not-allowed';
});